"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectRegistrySelectors = void 0;
const getSelectStateById = (state, id) => state[id];
exports.selectRegistrySelectors = {
    getSelectStateById
};
